(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AlertasController', AlertasController)
 
    AlertasController.$inject = ["$scope","AlertasService","GenerallabService","$http","$timeout","$uibModal", "$document","$sce"];
              
    function AlertasController($scope,AlertasService,GenerallabService,$http,$timeout,$uibModal, $document,$sce)
    {                         
        var vm = this;
        console.log("AlertasController");
        vm.alertasActivas = [];
        vm.dameTodasLasAlertas = function(){
            console.log('dameTodasLasAlertas')
            AlertasService.getAllAlertas(function(data){
                console.log("dameTodasLasAlertas data getAllAlertas",data,vm);
                vm.alertasActivas = data.alertas;
            });
        }
        vm.dameTodasLasAlertasAgrupadas = function(){
            console.log('dameTodasLasAlertasAgrupadas')
            AlertasService.getAllAlertas(function(data){
                // console.log("dameTodasLasAlertas data getAllAlertas",data,vm);
                vm.alertasActivas = [];
                // vm.alertasActivas = data.alertas;
                data.alertas.forEach(alerta => {
                    alerta.fechadesde = alerta.created;
                    if (alerta.updated != "0000-00-00 00:00:00") {
                        alerta.fechadesde = alerta.updated;
                    }
                    var arrayDeCadenas = alerta.tipo.split("_");
                   
                    if (!vm.alertasActivas[arrayDeCadenas[0]]) {
                        vm.alertasActivas[arrayDeCadenas[0]] = [alerta];
                    } else {
                        vm.alertasActivas[arrayDeCadenas[0]].push(alerta)
                    }
                    

                });
                console.log('alertasActivas',vm.alertasActivas)
            });
        }
    }  
})();
